import { getSizeFilterConfig } from '../filters/size';
import { getDefaultShopConfig } from './default';
import * as custom from '../filters/marketplace-custom-config';
import { getConditionsFilterConfig } from '../filters/condition';
import { getBrandDirectFilterConfig } from '../filters/brandDirect';
import { getTagsFilterConfig } from '../filters/styles';
import { FilterId } from '../../types/filters/filters';

const hatleySizes: string[] = [
  '0-3M',
  '3-6M',
  '6-9M',
  '6-12M',
  '9-12M',
  '12-18M',
  '18-24M',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '10',
  '12',
  '14',
  'XXS',
  'XS',
  'S',
  'M',
  'L',
  'XL',
  'XXL',
  'O/S',
];

const hatleyTags = [
  { key: 'YCRF_Kids', label: 'Hatley Kids', tags: ['YCRF_Kids'] },
  { key: 'YCRF_Women', label: 'Hatley Adults', tags: ['YCRF_Women'] },
  { key: 'YCRF_LBH', label: 'Little Blue House Kids', tags: ['YCRF_LBH'] },
  { key: 'YCRF_LBH Adult', label: 'Little Blue House Adults', tags: ['YCRF_LBH Adult'] },
];

export const hatleyShopConfig = {
  ...getDefaultShopConfig(),
  filters: [
    ...custom.filters,
    getBrandDirectFilterConfig(),
    getConditionsFilterConfig(),
    getSizeFilterConfig({
      sizes: hatleySizes,
    }),
    getTagsFilterConfig({
      id: FilterId.Style,
      options: hatleyTags,
      shouldUseTreetOptions: true,
    }),
  ],
};
